import type { CheckoutV2Configuration } from "@jti/commerce";
import type { OrderAttribute } from "@jti/magento";
import type { MagentoShippingMethod } from "@jti/magento-types";
import type { LastCustomerOrder } from "@jti/store/slices/magentoApiSlice";
import type { AppDispatch } from "@jti/store/types";
import type { CheckoutGTMFlowType } from "@jti/tracker";

import type { PaymentOption } from "@checkout-v2/features/PaymentMethods/components/PaymentMethodsSection";
import type { ShippingFormFieldsConfig, ShippingFormFieldsDefaultValues } from "@checkout-v2/forms";
import type { usePhoneValidation } from "@checkout-v2/shared";

export type UseCheckoutFastFlowArgs = {
  ready: boolean;
  initialDefaultValues: ShippingFormFieldsDefaultValues | null;
  hasDefaultAddress: ShippingFormFieldsConfig["addressHomeDelivery"]["hasDefaultAddress"] | null;
  checkoutConfiguration: CheckoutV2Configuration;
  allDeliveryOptions: MagentoShippingMethod[];
  isSubscription?: boolean;
  dispatch: AppDispatch;
  lastOrderData: LastCustomerOrder;
  definedOrderAttributes: OrderAttribute[];
  paymentOptions: PaymentOption[];
  validatePhone: ReturnType<typeof usePhoneValidation>["validatePhone"];
  cartId: string | undefined;
  skip: boolean;
  isBillingAddressVisibleForCheckout: boolean;
  hasProfileFiscalCode: boolean;
  isShippingAgeVerificationEnabled: boolean;
  isAgeVerified: boolean;
  checkoutFlowType: CheckoutGTMFlowType | null;
  shippingInfoPrefilled: boolean;
  paymentInfoPrefilled: boolean;
};
